'use strict';

namespace Search {

    export class SearchQueryString {

        allAirlines: Airline[] = _.map((TRPCONFIG.Domain.PrefilterAirlines || '').split('|').filter(val => val !== ''),
            (a: string) => {
            const parts = a.split(',');
            return {
                Title: parts[0],
                Code: parts[1],
                IsPostfilter: parts[2] === '1'
            };
        });

        constructor (
            private $location: ng.ILocationService,
            private $q,
            private dateUtil,
            private occupancyService: Core.OccupancyService,
            private searchUnitService: Search.SearchUnitService,
            private destinationService,
            private autocompleter
        ) {
        }

        getQueryStringValues(paramsOptional: any = {}): ng.IPromise<string> {
            const params = this.getCompleteParamsObj(paramsOptional);
            const {startDate, endDate} = this.applyDatesOffset(
                params.startdate,
                params.enddate,
                params.startoffset,
                params.duration
            );

            return this.$q.all({
                startDate: this.dateUtil.parseDate(startDate),
                endDate: this.dateUtil.parseDate(endDate),
                occupancy: this.occupancyService.parseOccupancyString(params.occ),
                airports: params.depair && params.depair.indexOf(',') > -1
                        ? this.getAirportCodes(params.depair) : this.lookupAirports(params.depair),
                destination: this.getDestination(params),
                cabin: ('cabin' in params) ? this.lookupCabin(params.cabin) : undefined,
                prefilterDirectFlights: params.direct === '1' ? true : params.direct === '0' ? false : undefined,
                autoSearch: params.autosearch === '1',
                expandedOptions: ('expandedoptions' in params) ? params.expandedoptions === '1' : undefined,
                airlines: ('airlines' in params) ? this.lookupAirlines(params.airlines) : undefined,
                prefilterAirlines: ('airlines' in params) ? this.prefilterAirlines(params.airlines) : undefined,
                resetForm: params.resetform === '1' ? true : params.resetform === '0' ? false : undefined,
                sortOrder: parseInt( params.sortorder,10) > 0 ? parseInt( params.sortorder,10) : 0,
                dealsOnly: params.dealsonly,
                currency: params.currency && params.currency.toUpperCase(),
            });
        }

        lookupDestination(query: string): ng.IPromise<string>|undefined {
            if (query) {
                const destObj = this.parseDestinationParam(query);
                return this.destinationService.getDetails(destObj)
                    .then(d => d ? [d] : undefined);
            }
        }

        getAirportCodes(query:string): ng.IPromise<string> {
            const airports = query.split(',').map(prefix => {
                return { Code: prefix };
            });
            return this.$q.when(airports);
        }

        lookupAirports(query: string): ng.IPromise<string>|undefined {
            if (query) {
                return this.autocompleter.lookup('flights', query).then(response => {
                    let firstItem = response.data && response.data[0];
                    let codes = firstItem && response.data[0].Code && response.data[0].Code.split(',');
                    if (codes) {
                        if(codes.length === 1){
                            return [firstItem];
                        }
                        return _.map(codes, c => ({ Code: c }));
                    }
                });
            }
        }

        lookupAirlines(query: string) {
            query = query || '';
            const airlineQueryArray: Airline[] =
                _.map(query.split(','), q => ({Title: q, Code: q, IsPostfilter: undefined}));
            return this.verifyAirlineModels(airlineQueryArray);
        }

        prefilterAirlines(query: string) {
            query = query || '';
            const prefilterAirlinesArray = _.map(query.split(','), q => (q));
            return prefilterAirlinesArray;
        }

        lookupCabin(query: string) {
            let result = _.find(this.searchUnitService.getCabinOptions(), (c: Cabin) => c.queryStringCode === query);
            return result ? result.value : undefined;
        }

        verifyAirlineModels(airlineQueryArray: Airline[]) {
            airlineQueryArray = _.map(airlineQueryArray, (q: Airline) => ({
                Title: (q.Title || '').toUpperCase(),
                Code: (q.Code || '').toUpperCase(),
                IsPostfilter: q.IsPostfilter
            }));

            let isInQuery = airline => {
                return _.some(airlineQueryArray, q =>
                    airline.Title.toUpperCase() === q.Title || airline.Code === q.Code
                );
            };

            return _.filter(this.allAirlines, isInQuery);
        }


        private getCompleteParamsObj(params) {
            const searchParams = this.$location.search();
            if (searchParams.dealsOnly) {
                params.dealsOnly = 1;
            } else {
                params = angular.merge(params, searchParams);
            }
            params = _.mapKeys(params, (value: any,key: string)=> {
                return key.toLowerCase();
            });
            return params;
        }

        private parseDestinationParam(dest) {
            let parts = dest.split('-');
            return {
                Type: parts[0],
                Id: parts[1],
            };
        }

        private getAirportListCodes(depair: string): string[] {
            const depAirpts = depair && depair.split(',') || [];
            return depAirpts.map((depAirpt) => {
                return depAirpt.toUpperCase().trim();
            });
        }

        private getDestination(params) {
            return this.$q.all({
                destAir: this.lookupAirports(params.destair),
                dest: this.lookupDestination(params.dest)
            })
                .then(({ destAir, dest }) => destAir || dest);
        }

        private getValue(str, val) {
            let ls = JSON.parse(str);
            return ls[val];
        }

        private applyDatesOffset(startDate, endDate, startOffset, duration) {
            if(startOffset !== undefined && startOffset !== undefined) {
                let dateData = {
                    startOffset: startOffset,
                    duration: duration
                };
                sessionStorage.setItem('deeplinkData', JSON.stringify(dateData));
            }

            let deeplinkData = sessionStorage.getItem('deeplinkData');
            if(deeplinkData !== null) {
                startOffset = this.getValue(deeplinkData, 'startOffset');
                duration = this.getValue(deeplinkData, 'duration');
            }

            if(startOffset && duration) {
                let startDate = this.dateUtil.format(this.dateUtil.todayPlus(parseInt(startOffset, 10)),
                    'yyyy-MM-dd');
                let endDate = this.dateUtil.format(this.dateUtil.addDays(startDate, parseInt(duration, 10)),
                    'yyyy-MM-dd');

                let dates =  {
                    startDate: startDate,
                    endDate: endDate
                };
                return dates;
            }
            return {startDate, endDate};
        }

        getDeepLinkQSParams() {
            const params = this.getCompleteParamsObj({});
            const {startDate, endDate} = this.applyDatesOffset(
                params.startdate,
                params.enddate,
                params.startoffset,
                params.duration
            );

            return {
                TenantId: TRPCONFIG.Domain.TenantId,
                DepartureAirports: this.getAirportListCodes(params.depair),
                Cabin: this.lookupCabin(params.cabin),
                CountryCode: TRPCONFIG.Domain.CountryCode.toUpperCase(),
                CultureCode: TRPCONFIG.Domain.CultureCode.toUpperCase(),
                StartDate: startDate,
                EndDate: endDate,
                Rooms: this.occupancyService.parseOccupancyString(params.occ),
                Destination: this.parseDestinationParam(params.dest)
            };
        }
    }

    angular
        .module('search')
        .service('searchQueryString', SearchQueryString);
}
